import React, {memo} from 'react';
import {onClickHandler} from '../../../utils/onclick';

import './index.scss';

type ACheckBoxProps = {
    label: string;
    set: () => void;
    value: boolean;
};

export const SettingCheckBoxComponent = memo(function SettingCheckBoxComponent({label, set, value}: ACheckBoxProps) {
    return (
        <div className='line'>
            <div className='left'>
                <span>{label}</span>
            </div>
            <div className='right'>
                <div {...onClickHandler(set)} className={'checkmark' + (value ? ' checked' : '')}/>
            </div>
        </div>
    );
});
